import { Col } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { TileContainer } from '~src/styles/containers.sc';
import SelectInput from '~src/shared/form/select/SelectInput';
import { SbPositionT } from '~src/shared/snackbar/SnackbarNotifications';
import {
  showNotification,
  notificationPositionUpdated,
  removeNotification,
} from '~src/store/app/actions';
import { ShowNotification } from '~src/store/app/interfaces';
import { StoreI } from '~src/rootReducer';
import { SectionHeader, SectionBody, SubSection } from '~src/shared/form/shared.sc';

interface StateProps {
  notificationsPosition: SbPositionT | undefined;
}

interface DispatchProps {
  showNotification: ShowNotification;
  removeNotification(id: string): void;
  setNotifPos(position: SbPositionT): void;
}

type Props = StateProps & DispatchProps;

const NotificationsSettings: FC<Props> = props => {
  const [t] = useTranslation();
  const optList: Array<{ name: string; value: SbPositionT }> = [
    // Disabled untill be requested
    // { name: 'Top', value: 'top' },
    // { name: 'Top Left', value: 'topLeft' },
    // { name: 'Top Right', value: 'topRight' },
    { name: t('x.notifications_settings.bottom_left_select_option'), value: 'bottomLeft' },
    { name: t('x.notifications_settings.bottom_select_option'), value: 'bottom' },
    { name: t('x.notifications_settings.bottom_right_select_option'), value: 'bottomRight' },
  ];

  const changePosition = (value: string) => {
    if (props.notificationsPosition) {
      props.removeNotification(props.notificationsPosition);
    }

    props.setNotifPos(value as SbPositionT);
    props.showNotification({
      id: value,
      txtKey: 'x.notifications_settings.test_notification',
    });
  };

  return (
    <TileContainer>
      <SectionHeader data-translation="x.profile_settings.notifications_settings_title">
        {t('x.profile_settings.notifications_settings_title')}
      </SectionHeader>
      <SectionBody>
        <SubSection>
          <Col lg={8}>
            <SelectInput
              t={t}
              labelKey="x.profile_settings.notifications.select_label"
              optList={optList}
              value={props.notificationsPosition}
              defaultValue={props.notificationsPosition}
              onChange={changePosition}
            />
          </Col>
        </SubSection>
      </SectionBody>
    </TileContainer>
  );
};

const mapState2Props = ({ app }: StoreI): StateProps => ({
  notificationsPosition: app.settings.notificationsPosition,
});

const mapDispatch2Props = (dispatch: any): DispatchProps => ({
  setNotifPos: position => dispatch(notificationPositionUpdated(position)),
  showNotification: notification => dispatch(showNotification(notification)),
  removeNotification: id => dispatch(removeNotification(id)),
});

export default connect(mapState2Props, mapDispatch2Props)(NotificationsSettings);
